import { FormattedMessage } from 'react-intl'

import { IncomingActionsMessage } from '~/App/components/messages/IncomingActionsMessage'
import { MessageAction, MessageActions } from '~/App/components/messages/MessageActions'

type PreviewMessageProps = {
  message?: string
}

export function PreviewMessage({ message }: PreviewMessageProps) {
  return (
    <IncomingActionsMessage time={Date.now()}>
      <div>{message}</div>
      <MessageActions>
        <MessageAction variant="secondary" className="text-tertiary hover:text-tertiary">
          <FormattedMessage id="preview.message.cancel" />
        </MessageAction>
        <MessageAction className="border-none">
          <FormattedMessage id="preview.message.goToPay" />
        </MessageAction>
      </MessageActions>
    </IncomingActionsMessage>
  )
}
